import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-card.js';
import '@adornis/chemistry/elements/components/x-link.js';
import { makeChancenRouter } from '@chancenwerk/client/make-chancen-router.js';
import { authenticationGuard } from '@adornis/user-forms/authentication-guard.js';
import { permissionGuard } from '@adornis/user-forms/permission-guard.js';
import { ANY_CONTEXT } from '@adornis/users/db/a-roles.js';
import '@chancenwerk/client/components/chancen-component-auto-navigation.js';
import { ChancenPermission } from '@chancenwerk/shared/permissions.js';
import '@chancenwerk/client/design/components/cr-flex.js';
import '@chancenwerk/client/design/components/cr-loader.js';
import '@chancenwerk/client/design/components/cr-sidebar.js';
import '@chancenwerk/client/design/components/fonts.js';
import { watch } from '@lit-labs/preact-signals';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '@chancenwerk/client/components/chancen-component-login-redirect.js';
import '@chancenwerk/client/pages/chancen-page-no-permission.js';
import '@chancenwerk/client/pages/chancen-page-not-found.js';
import './components/akademie-component-sidebar.js';
import './pages/akademie-page-workshop-appointment.js';
import './pages/akademie-page-workshop-appointments.js';
import './pages/akademie-page-workshop-reg.js';
import './pages/akademie-page-workshop.js';
import './pages/akademie-page-workshops-reporting.js';
import './pages/akademie-page-workshops.js';

const router = makeChancenRouter(
  {
    root: {
      path: '/',
      render: () => html`<akademie-page-workshops></akademie-page-workshops>`,
    },
    workshop: {
      path: '/workshop/:id',
      render: ({ id }) => html`<akademie-page-workshop .workshopID=${id}></akademie-page-workshop>`,
    },
    appointments: {
      path: '/appointments',
      render: () => html`<akademie-page-workshop-appointments></akademie-page-workshop-appointments>`,
    },
    appointment: {
      path: '/appointment/:id',
      render: ({ id }) =>
        html`<akademie-page-workshop-appointment .appointmentID=${id}></akademie-page-workshop-appointment>`,
    },
    reporting: {
      path: '/reporting',
      render: () => html`<akademie-page-workshops-reporting></akademie-page-workshops-reporting>`,
    },
  },
  {
    routerDocumentTitle: 'CHANCENakademie',
    fallback: () => {
      return html`<chancen-page-no-permission></chancen-page-no-permission>`;
    },
  },
).init();

@customElement('main-element')
export class MainElement extends ChemistryLitElement {
  override styles() {
    return [{ ':host': { background: this.colors.neutral.shade(50) } }];
  }

  public override render() {
    return authenticationGuard(
      () => {
        return html`${permissionGuard(
          ChancenPermission.akademie.LOGIN_AKADEMIE,
          () => html`
            <cr-flex flex ${css({ height: '100%' })}>
              <cr-flex horizontal h100>
                <akademie-component-sidebar></akademie-component-sidebar>
                <cr-flex id="outer-flex" flex ${css({ overflowY: 'auto', position: 'relative' })}>
                  ${watch(router.outlet)}
                </cr-flex>
              </cr-flex>
            </cr-flex>
          `,
          {
            forbiddenTemplate: html`<chancen-page-no-permission></chancen-page-no-permission>`,
            context: ANY_CONTEXT,
          },
        )}`;
      },
      html`<chancen-component-login-redirect></chancen-component-login-redirect>`,
    );
  }
}
